export default function FooterBar() {
  return (
    <div className="tw-px-4 tw-py-2 tw-border-t tw-border-gray-100 tw-text-[10px] tw-text-gray-400 tw-flex tw-items-center tw-gap-1">
      <span>수신거부</span>
      <span className="tw-mx-1">|</span>
      <span>홈</span>
      <span className="tw-text-[8px]">&gt;</span>
      <span>채널차단</span>
    </div>
  );
}
